import { render } from "./VisionTwoFilters.vue?vue&type=template&id=01341638"
import script from "./VisionTwoFilters.vue?vue&type=script&lang=js"
export * from "./VisionTwoFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__